<template>
  <div class="p-4 flex flex-col items-center justify-around">
    <span class="font-black text-4xl text-default font-title">{{ title }}</span>
    <Achievement :key="index" v-for="(position, index) in this.positions" class="p-2"
                 :title="position[0]"
                 :position="position[1]"
                 :img="position[2]"
                 :attachmentOne="position[3]"
                 :attachmentTwo="position[4]"
                 :desc="position[5]"
                 :images="position[6]"
                 :index="title !== 'Current Position' ? index : 1"/>
  </div>
</template>

<script>
import Achievement from '@/components/Achievement.vue'

export default {
  name: 'AchievementHolder',
  components: {
    Achievement
  },
  props: {
    title: {
      type: String,
      required: true
    },
    positions: {
      type: Array,
      required: true
    }
  },
  created: function () {
    console.log(this.positions)
  }
}
</script>

<style scoped>

</style>
